export enum EStatus {
  Active = 'Active',
  New = 'New',
  Inactive = 'Inactive',
  Used = 'Used',
  Valid = 'Valid',
}
